export { TableCellResult } from './table-cell-result';
